import {
  useEffect,
  useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Typography
} from '@mui/material';
import Select from '../components/SearchableSelect';
import { eliminaStanza, getAllStanze, getStanzaById } from '../APIs/RoomsAPI';
import { useTranslation } from 'react-i18next';
import { eliminaTavolo } from '../APIs/TablesAPI';
import { getTenantTranslation } from '../utils/getTenantTranslation';
import { useSnackbar } from '../contexts/SnackBarContext';

const ModalDeleteSala = ({ open, onClose }) => {
  const [roomId, setRoomId] = useState();
  const [stanze, setStanze] = useState([]);
  const [errTavoli, setErrTavoli] = useState(false)

  const [openConfirmDelete, setOpenConfirmDelete] = useState(false)

  const { t } = useTranslation()
  const tenantType = localStorage.getItem('tenantType');
  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    if (open) {
      const token = localStorage.getItem('accessToken');
      const tenant = localStorage.getItem('tenantId');
      getAllStanze(token, tenant).then(data => setStanze(data)).catch(err => console.error(err));
    }
  }, [open]);

  const handleDelete = async () => {
    const token = localStorage.getItem('accessToken');
    const tenant = localStorage.getItem('tenantId');

    setErrTavoli(false)

    if (!roomId) return;

    //Otteni i tavoli dalla sala da cancellare
    async function ottieniStanzaById() {
      try {
        return await getStanzaById(roomId, token, tenant);
      } catch (err) {
        setErrTavoli(true)
        handleAlert(t("modals_alert.error_getTable") + err.message, "error");
        return null
      }
    }
    //ciclo per cancellare i tavoli dalla sala
    async function cancellaTavoliDaSala() {

      idTavoliDaEliminare.forEach(async (idTavolo) => {
        try {
          await eliminaTavolo(idTavolo, token, tenant);
        } catch (err) {
          setErrTavoli(true)
          handleAlert(t("modals_alert.error_deleteTable") + err.message, "error");
        }
      });


    }
    //per cancellare la sala
    async function cancellaSala() {
      try {
        await eliminaStanza(roomId, token, tenant);
        handleClose()

      } catch (err) {
        setErrTavoli(true)
        handleAlert(t("modals_alert.error_deleteRoom")+err.message, "error");
      }
    }
    const stanzaById = await ottieniStanzaById()

    if (!stanzaById) return;

    const idTavoliDaEliminare = [];
    stanzaById.tables.map((tavolo) => {
      idTavoliDaEliminare.push(tavolo.id)
    });

    await cancellaTavoliDaSala()
    await cancellaSala()


  };

  const handleClose = () => {
    setRoomId('');
    setErrTavoli(false)
    setOpenConfirmDelete(false)
    onClose();
  };

  function handleAlert(msg, type) {
    showSnackbar(msg, type)
  }

  return (<>

    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{getTenantTranslation(t, tenantType, 'deleteRoom')}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel id="room-label">{getTenantTranslation(t, tenantType, 'booking.room')}</InputLabel>
          <Select
            labelId="room-label"
            value={roomId}
            label={getTenantTranslation(t, tenantType, "booking.room")}
            onChange={(e) => setRoomId(e.target.value)}
          >
            {stanze.map((stanza) => (
              <MenuItem key={stanza.id} value={stanza.id}>
                {stanza.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{getTenantTranslation(t, tenantType, 'cancel')}</Button>
        <Button onClick={() => { setOpenConfirmDelete(true) }} variant="contained" disabled={!roomId}>
          {/* <Button onClick={handleDelete} variant="contained" disabled={!roomId}> */}
          {getTenantTranslation(t, tenantType, 'delete')}
        </Button>
      </DialogActions>
    </Dialog>
    {openConfirmDelete &&
      <Dialog open={openConfirmDelete} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle> {getTenantTranslation(t, tenantType, 'deleteRoomRequestTitle')} </DialogTitle>
        <DialogContent> {getTenantTranslation(t, tenantType, 'deleteRoomRequest')} </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{getTenantTranslation(t, tenantType, 'cancel')}</Button>
          <Button onClick={handleDelete} variant="contained" disabled={!roomId}>{getTenantTranslation(t, tenantType, 'delete')}</Button>
        </DialogActions>
      </Dialog>
    }
  </>
  );
};

export default ModalDeleteSala;